import SodMitigateListItem from './SodMitigateListItem';

export default SodMitigateListItem;
